import { render, staticRenderFns } from "./ChangePublishesAtButton.vue?vue&type=template&id=5127bffd&"
import script from "./ChangePublishesAtButton.vue?vue&type=script&lang=ts&"
export * from "./ChangePublishesAtButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports